import { Autocomplete, TextField } from '@mui/material';
import { useMemo, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';

const VatInput = ({ countryCode, vatNumber, handleCountry, handleVat }) => {
    const countriesData = JSON.parse(localStorage.getItem('countries'));

    const [searchedCountry, _searchedCountry] = useState('');
    const [country, _country] = useState(countryCode);

    const filteredCountry = useMemo(() => {
        if (!countriesData || countriesData.length < 1) return [];

        if (!searchedCountry || searchedCountry.length < 1) return countriesData;

        return countriesData.filter(
            (country) =>
                country.country_name.includes(searchedCountry.toUpperCase()) ||
                country.country_name.toLowerCase().includes(searchedCountry.toLowerCase())
        );
    }, [searchedCountry, countriesData]);


    const handleVATInput = (e) => {
        const inputValue = e.target.value;
        handleVat(inputValue);
        handleCountry(countryCode)
    }

    return (
        <Wrapper>
            {/* ✅ Global styles for listbox rendered in a portal */}
            <GlobalStyles />

            <StyledAutocomplete
                disableClearable
                options={filteredCountry}
                getOptionLabel={(option) => option.country_name || ''}
                renderOption={(props, option) => (
                    <li {...props} key={option.country_name} className="options">
                        <img src={option.flag_thumbnail} alt={option.country_name} />
                        <span>{option.country_name}</span>
                    </li>
                )}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,
                        }}
                        placeholder='Prefix'
                        sx={{
                            '& .MuiInputBase-root': {
                                border: 'none !important',
                                outline: 'none !important',
                                boxShadow: 'none !important',
                            },
                            '& .MuiInputBase-input': {
                                padding: '4px 10px !important',
                            },
                        }}
                    />
                )}
                value={country}
                onChange={(_, value) => {
                    _country(value);
                    handleCountry?.(value?.country_name || "");
                }}
                ListboxProps={{
                    className: 'autocomplete-listbox', // ✅ add custom class for styling the popup
                }}
            />

            <input
                disabled={!country}
                type="text"
                className={`${!country ? 'disabled' : ''} vat-number`}
                placeholder="VAT Number"
                value={vatNumber}
                onChange={handleVATInput}
            />
        </Wrapper>
    );
};

export default VatInput;

//
// ✅ Styled Components
//

const Wrapper = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  max-height: 32px;
  overflow: hidden;

  .vat-number {
    border: none;
    border-left: 1px solid rgba(0, 0, 0, 0.2);
    padding: 10px;
    flex: 1;
    outline: none;
  }
`;

const StyledAutocomplete = styled(Autocomplete)`
  flex: 1;
  width: 80px;

  & .MuiOutlinedInput-root {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
  }

  & .MuiOutlinedInput-notchedOutline {
    border: none !important;
  }

  & .MuiAutocomplete-inputRoot {
    padding: 0 !important;
  }

  & .MuiAutocomplete-popupIndicator,
  & .MuiAutocomplete-clearIndicator {
    display: none !important;
  }
`;

// ✅ Global styles for portal-based listbox
const GlobalStyles = createGlobalStyle`
  .autocomplete-listbox {
    padding: 0 !important;
    margin: 0 !important;
  }

  .autocomplete-listbox .options {
    display: flex !important;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    cursor: pointer;
  }

  .autocomplete-listbox .options img {
    width: 25px;
    height: 15px;
  }
`;
